<template>
<div class="rechargeDialog" v-if="dialogVisible">
    <el-dialog title="充值金额" class="recharge" :visible.sync="dialogVisible" @close='cancel'>
        <div class="top">
            <p class="title">充值金额</p>
            <template v-for="item in moneyList">
                <input type="radio" name="money" :id="'money_'+item">
                <label :for="'money_'+item" @click="setFastMoney(item)">
                    <p>{{item}}</p>
                </label>
            </template>
        </div>
        <div class="bottom">
            <p class="title">自定义金额</p>
            <el-input type="tel" v-model="money" placeholder="输入金额" width="166px" @input="setMoney"></el-input>
            <p>输入金额需大于1小于9999的整数</p>
        </div>
        <p class="tips">
            充值金额不可提现，当前充值金额{{topUpMoney}}元+{{serviceCharge}}（{{topUpMoney}}x1%）服务费={{parseFloat(topUpMoney)+parseFloat(serviceCharge)}}元（含银行交易手续费）</p>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submitMoney" :disabled="buttonDisabled">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {hostrecharge, queryrechargeresult} from '@/api/marketingCenterApi' // 引入粉丝管理 api 资源文件
export default {
    name: 'rechargeDialog',
    data() {
        return {
            dialogVisible: false,
            serviceCharge: 0.01, // 手续费
            moneyList: [50, 100, 500, 1000],
            checkMoney: '',
            topUpMoney: '',
            money: '',
            buttonDisabled: true,
            czialogVisible: false,
            hostroletype: '',
            hostroleinnerid: ''
        }
    },
    mounted() {
    },
    methods: {
        openDialog(hostroletype) {
            this.hostroletype = hostroletype
            if (this.hostroletype == 2) {
                this.hostroleinnerid = this.brandBusiness.hostid
            } else if (this.hostroletype == 4) {
                this.hostroleinnerid = this.user.providerinnerid
            } else {
                this.hostroleinnerid = ''
            }
            this.dialogVisible = true
        },
        cancel() {
            this.checkMoney = ''
            this.topUpMoney = ''
            this.money = ''
            this.buttonDisabled = true
            this.dialogVisible = false
        },
        setFastMoney(obj) {
            this.checkMoney = obj
            this.topUpMoney = obj
            this.buttonDisabled = false
        },
        setMoney(e) {
            this.checkMoney = 0
            if (Number(e) >= 1 && Number(e) < 9999) {
                if (/^[0-9]*[1-9][0-9]*$/.test(e)) {
                    this.topUpMoney = Number(e)
                    this.buttonDisabled = false
                } else {
                    this.buttonDisabled = true
                    this.$message.error('输入金额需大于1小于9999的整数')
                }
            } else {
                this.buttonDisabled = true
                this.$message.error('输入金额需大于1小于9999的整数')
            }
            $("input[name=money]:checked").prop("checked", false)
        },
        submitMoney() {
            let money = this.money,
                checkMoney = this.checkMoney,
                m = 0
            if (parseFloat(this.topUpMoney) >= 1 && parseFloat(this.topUpMoney) < 9999) {
                let data = {
                    LoginToken: this.user.loginToken,
                    ShopID: this.shop.ShopID,
                    money: this.topUpMoney,
                    feemoney: this.serviceCharge,
                    hostroletype: this.hostroletype,
                    hostroleinnerid: this.hostroleinnerid
                }
                this.setLoading(true)
                hostrecharge({
                    data: data,
                    success: data => {
                        this.setLoading(false)
                        // 打开充值窗口
                        window.open(data.data.url)
                        this.dialogVisible = false
                        // 打开充值弹窗状态查询窗口
                        // this.czialogVisible = true
                        // this.czDataApi = {
                        //     LoginToken: this.token,
                        //     ShopID: this.shopID,
                        //     orderno: data.data.orderno,
                        //     sign: data.data.ordersign,
                        //     hostroletype: this.hostroletype,
                        //     hostroleinnerid: this.hostroleinnerid
                        // }
                        // 遍历充值状态
                        // this.czInterval = setInterval(() => {
                        //     queryrechargeresult({
                        //         data: this.czDataApi,
                        //         success: data => {
                        //             if (data.code == '000') {
                        //                 clearInterval(this.czInterval)
                        //                 this.czStatus = 2
                        //                 this.rechargeData = data.data
                        //             }
                        //         },
                        //         error: data => {
                        //             console.log(data)
                        //         }
                        //     })
                        // }, 30000)
                    },
                    error: data => {
                        this.setLoading(false)
                    }
                })
            } else {
                this.$message.error('输入金额需大于1小于9999的整数')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user', 'shop', 'brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.rechargeDialog {
    .recharge {
        .top {
            .title {
                display: inline-block;
                float: left;
                color: #303133;
                line-height: 32px;
            }
            input {
                display: none
            }
            input[type=radio]:checked + label {
                position: relative;
                border-color: #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../../../common/images/starMgtHeaderimg/radio.png") no-repeat center;
                background-size: 23px;
            }

            label {
                margin-left: 29px;
                display: inline-block;
                width: 95px;
                height: 32px;
                text-align: center;
                cursor: pointer;
                border: 1px solid rgba(220, 223, 230, 1);
                border-radius: 2px;

                p {
                    font-size: 14px;
                    color: #606266;
                    line-height: 32px;
                }
            }
        }

        .bottom {
            margin-top: 22px;

            p {
                color: #C0C4CC;
            }
            p, input {
                display: inline-block;
                font-size: 14px;
                line-height: 32px;
            }
            .title {
                float: left;
                color: #303133;
            }

            .el-input {
                margin-left: 15px;
                margin-right: 10px;
                width: 166px;
            }

        }
        .tips {
            margin-top: 10px;
            color: #C0C4CC;
            font-size: 14px;
            line-height: 32px;
            padding-left: 85px;
            box-sizing: border-box;
        }
    }
}
</style>
